"use client";

import React from "react";
import { Check, Sparkles } from "lucide-react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: 1,
  title: "The Art of Beauty",
  price: "£45",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/beauty_pillar.png",
  link: "/BeautyPage"
}, {
  id: 2,
  title: "Advanced Aesthetics",
  price: "£120",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/aesthetics_pillar.png",
  link: "https://nataliasbeauty.com/aesthetics/"
}, {
  id: 3,
  title: "Restorative Massage",
  price: "£65",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/massage_pillar.png",
  link: "https://nataliasbeauty.com/massage/"
}];
const inclusions = [{
  serviceId: 1,
  text: "Bespoke Manicures & Pedicures"
}, {
  serviceId: 1,
  text: "Lash & Brow Artistry"
}, {
  serviceId: 1,
  text: "Precision Waxing Rituals"
}, {
  serviceId: 1,
  text: "HD Brows & Lamination"
}, {
  serviceId: 1,
  text: "Luxury Tinting Treatments"
}, {
  serviceId: 2,
  text: "Advanced Skin Peels"
}, {
  serviceId: 2,
  text: "Dermal Fillers & Anti-Wrinkle"
}, {
  serviceId: 2,
  text: "Microneedling Therapy"
}, {
  serviceId: 2,
  text: "Vitamin Injections"
}, {
  serviceId: 2,
  text: "Skin Booster Treatments"
}, {
  serviceId: 3,
  text: "Deep Tissue Release"
}, {
  serviceId: 3,
  text: "Hot Stone Therapy"
}, {
  serviceId: 3,
  text: "Aromatherapy Rituals"
}, {
  serviceId: 3,
  text: "Swedish Massage"
}, {
  serviceId: 3,
  text: "Lymphatic Drainage"
}];
export default function OurPamperingMenu() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="74483" id="our-three-pillars" className="py-24 bg-gradient-to-b from-background via-primary/20 to-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary/30 blur-[100px]" />
        <div className="absolute top-[60%] -right-[10%] w-[40%] h-[60%] rounded-lg bg-secondary/30 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {}
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-1000 ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center gap-2 px-5 py-2 mb-6 rounded-lg bg-secondary/60 text-secondary-foreground text-xs font-sans tracking-widest uppercase">
            <Sparkles className="w-3.5 h-3.5 text-ring" />
            <span>The Sanctuary</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-light text-foreground mb-8 font-serif tracking-widest">
            Our Three Pillars
          </h2>
          <p className="text-xl text-muted-foreground/80 max-w-3xl mx-auto font-sans leading-relaxed">
            A curated sanctuary where clinical precision meets holistic tranquility. Explore our dedicated realms of beauty, skin aesthetics, and restorative massage rituals.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, i) => <Card key={service.id} data-index={i} className="group relative overflow-hidden border-border/30 bg-card/60 backdrop-blur-md shadow-sm transition-all duration-700 hover:-translate-y-2 hover:shadow-xl flex flex-col h-full">
              {}
              <div className="relative aspect-[4/3] overflow-hidden rounded-t-[2.5rem] bg-muted">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
                <Badge variant="secondary" className="absolute top-6 right-6 bg-background/90 text-foreground backdrop-blur-md border-none shadow-sm font-sans tracking-tight px-4 py-2 text-xs rounded-lg">
                  From {service.price}
                </Badge>
              </div>

              <CardHeader className="pb-4 pt-10 px-8">
                <CardTitle className="text-3xl font-serif font-light text-foreground tracking-wide">
                  {service.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="flex-grow px-8">
                <ul className="space-y-4">
                  {inclusions.filter(inc => inc.serviceId === service.id).map((inc, j) => <li key={j} data-index={j} className="flex items-start gap-4 text-muted-foreground/90">
                        <div className="mt-1 bg-primary/40 rounded-lg p-1 shrink-0">
                          <Check className="w-3.5 h-3.5 text-ring" />
                        </div>
                        <span className="text-sm font-sans tracking-normal leading-snug">{inc.text}</span>
                      </li>)}
                </ul>
              </CardContent>

              <CardFooter className="pt-8 pb-10 px-8">
                <Button asChild size="lg" className="w-full rounded-lg py-7 text-xs font-sans tracking-widest uppercase transition-all duration-500 opacity-0 group-hover:opacity-100 bg-primary text-primary-foreground hover:bg-ring hover:text-white hover:shadow-[0_0_30px_rgba(184,159,102,0.3)]">
                  <Link to={service.link}>
                    Explore Rituals
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}